import { arrayOf, string, element } from 'prop-types';

import * as styles from './styles/styles.module.scss';

const BulletList = ({ list, bullet, classes }) => {
  return (
    <ul className={`${classes} ${styles.list}`}>
      {list.map((item, index) => {
        return (
          <li key={index} className={styles.item}>
            {bullet && <span className={styles.bullet}>{bullet}</span>}
            <span>{item}</span>
          </li>
        );
      })}
    </ul>
  );
};

BulletList.defaultProps = {
  bullet: null,
  classes: ''
};

BulletList.propTypes = {
  list: arrayOf(string).isRequired,
  bullet: element,
  classes: string
};

export default BulletList;
